import React from 'react';
import Hero from '../../components/hero/Hero';

import s from './SavingAccounts.module.css'
import { useTranslation } from 'react-i18next';

import handsImg from '../../assets/img/hands_with_money.png'
import hands_card from '../../assets/img/hands_card.png'
import woomanImg from '../../assets/img/modern-woman.png'
import ornaments from '../../assets/img/ornaments.png'

import CustomBtnBlue from '../../components/ui/customBtnBlue/CustomBtnBlue';
import { Navigate, NavLink } from 'react-router-dom';
import i18n from '../../i18n';


const SavingAccounts = () => {

     const [openItems, setOpenItems] = React.useState([false, false]);

    const toggleAccordion = (index: number) => {
        setOpenItems(prev => prev.map((item, i) => i === index ? !item : false));
    };

    

    const { t } = useTranslation();
    return (
        <div className={s.content}>
            <div className={s.paragraph1}>
                <Hero
                    title_1={t('savingAccounts.heroTitle1')}
                    title_2={t('savingAccounts.heroTitle2')}
                    description={t('savingAccounts.heroDescription')}
                />
            </div>
            <div className={s.paragraph2}>
                <div className={s.left_paragraph}>
                    <img src={handsImg} alt="" />
                </div>
                <div className="right_paragraph">
                    <p className={s.right_content}>
                       {t('savingAccounts.paragraph1.par1content')}
                    </p><br/><br/>
                    <p className={s.right_content}>
                       {t('savingAccounts.paragraph1.par1content2')}
                    </p>
                </div>
            </div>
            <div className={s.paragraph3}>
                <h2 className={s.title_pr3}>
                    {t('savingAccounts.paragraph2.title')}
                </h2>
                <div className={s.plan_items_row}>
                    <div className={s.plan_item}>
                        
                        <div className={s.plan_card}>
                            <h2 className={s.plan_item_account}>
                                {t('savingAccounts.paragraph2.usdAccount')}
                            </h2>
                            <div className={s.upper_container_card}>
                                <h3 className={s.plan_card_title}>
                                    12%
                                </h3>
                                <span>{t('savingAccounts.paragraph2.procentElsubContent')}</span>
                            </div>
                            <div className={s.middle_container_card}>
                                {/* Maybe need in future */}
                                {/* <h3 className={s.plan_middle_title}>
                                    12 {t('savingAccounts.paragraph2.monthCard')}
                                </h3>
                                <span>{t('savingAccounts.paragraph2.accountType')}</span> */}
                            </div>
                            <div className={s.lower_container_card}>
                                <h3 className={s.plan_middle_title}>
                                    500 €
                                </h3>
                                <span>{t('savingAccounts.paragraph2.depositCard')}</span>
                            </div>
                        </div>
                        {/* Maybe need in future */}
                        {/* <p className={s.descr_card}>
                            {t('savingAccounts.paragraph2.cardDescrAfter')}
                        </p> */}
                    </div>
                    <div className={s.plan_item}>
                        <div className={s.plan_card}>
                            <h2 className={s.plan_item_account}>
                                {t('savingAccounts.paragraph2.eurAccount')}
                            </h2>
                            <div className={s.upper_container_card}>
                                <h3 className={s.plan_card_title}>
                                    10%
                                </h3>
                                <span>{t('savingAccounts.paragraph2.procentElsubContent')}</span>
                            </div>
                            <div className={s.middle_container_card}>
                                {/* Maybe need in future */}
                                {/* <h3 className={s.plan_middle_title}>
                                    9 {t('savingAccounts.paragraph2.monthCard')}
                                </h3>
                                <span>{t('savingAccounts.paragraph2.accountType')}</span> */}
                            </div>
                            <div className={s.lower_container_card}>
                                <h3 className={s.plan_middle_title}>
                                    500 €
                                </h3>
                                <span>{t('savingAccounts.paragraph2.depositCard')}</span>
                            </div>
                        </div>
                        {/* Maybe need in future */}
                        {/* <p className={s.descr_card}>
                            {t('savingAccounts.paragraph2.cardSecondDescrAfter')}
                        </p> */}
                    </div>
                </div>
            </div>
            
            <div className={`${s.paragraph4} ${i18n.language === 'fas' ? s.rtl : ''}`}>
                    <div className={s.left_component_img}>
                        <img src={hands_card} alt="" />
                    </div>
                    <div className={s.right_par4_text}>
                        <span className={s.important_right_text}> {t('savingAccounts.paragraph3.importantcontent')}</span> {t('savingAccounts.paragraph3.content')}
                    </div>
            </div>
            <div className={s.paragraph5}>
                <div className={`${s.accordion} ${openItems[0] ? s.open : ''}`}>
                    <div 
                        className={s.accordionHeader}
                        onClick={() => toggleAccordion(0)}
                    >
                        <h3 className={s.accordionTitle}>
                            {t('savingAccounts.paragraph5.par5Block1.titleBlock')}
                        </h3>
                        <span className={s.accordionIcon}>
                            {openItems[0] ? '−' : '+'}
                        </span>
                    </div>
                    {openItems[0] && (
                        <div className={s.accordionContent}>
                            <p>{t('savingAccounts.paragraph5.par5Block1.interest')}</p>
                            <p>{t('savingAccounts.paragraph5.par5Block1.terms')}</p>
                            <p>{t('savingAccounts.paragraph5.par5Block1.entry')}</p>
                            <p>{t('savingAccounts.paragraph5.par5Block1.debitCard')}</p>
                        </div>
                    )}
                </div>

                <div className={`${s.accordion} ${openItems[1] ? s.open : ''}`}>
                    <div 
                        className={s.accordionHeader}
                        onClick={() => toggleAccordion(1)}
                    >
                        <h3 className={s.accordionTitle}>
                            {t('savingAccounts.paragraph5.par5Block2.titleBlock')}
                        </h3>
                        <span className={s.accordionIcon}>
                            {openItems[1] ? '−' : '+'}
                        </span>
                    </div>
                    {openItems[1] && (
                        <div className={s.accordionContent}>
                            <p>{t('savingAccounts.paragraph5.par5Block2.wallStreetSaving')}</p>
                            <p>{t('savingAccounts.paragraph5.par5Block2.moneyExceeding')}</p>
                        </div>
                    )}
                </div>
            </div>
            <div className={`${s.paragraph6} ${i18n.language === 'fas' ? s.rtl : ''}`}>
                <div className={s.left_par6}>
                    <h2 className={s.left_par6_title}>
                        {t('savingAccounts.paragraph6.posterTitle')}
                    </h2>
                    <p className={s.part_6_descr}>
                        {t('savingAccounts.paragraph6.posterDescr')}
                    </p>
                    <div>
                        <NavLink to='/open_account'>
                        <CustomBtnBlue title={t('savingAccounts.btnAccount')} />
                        </NavLink>
                    </div>
                    
                </div>
                <div className={s.right_part6}>
                    <img src={woomanImg} alt="" />
                </div>
            </div>
        </div>
    );
};

export default SavingAccounts;